import { render } from "./SortTableAbsenceTypeComponent.vue?vue&type=template&id=2fc9185a&scoped=true"
import script from "./SortTableAbsenceTypeComponent.vue?vue&type=script&lang=js"
export * from "./SortTableAbsenceTypeComponent.vue?vue&type=script&lang=js"

import "./SortTableAbsenceTypeComponent.vue?vue&type=style&index=0&id=2fc9185a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc9185a"]])

export default __exports__